var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_c",staticStyle:{"width":"100%"}},[_c('video',{ref:"videoPlayer",attrs:{"controlslist":"nodownload","controls":_vm.control,"src":_vm.Fn.hashToUrl(_vm.src),"preload":"meta","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }